export default "__VITE_ASSET__OMwgfm8X__"